import { Box, Text } from '@simplywallst/ui-core';
import { ReactNode } from 'react';

type Props = {
  children: NonNullable<ReactNode>;
};

// TODO UI-core
export const Badge = ({ children }: Props) => {
  return (
    <Box
      borderRadius="x2"
      backgroundColor="chart05"
      paddingX="x1"
      paddingY="x0_25"
    >
      <Text as="span" typography="tinyStrong" color="white">
        {children}
      </Text>
    </Box>
  );
};
